import React, { useState, useEffect } from 'react'
import moment from 'moment'

// components
import AppCard from 'src/components/AppCard'
import AppTable from 'src/components/AppTable'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// helpers
import { columnCustomerList } from 'src/components/table-column/TableColumnList'
import { formUrlQuery } from 'src/helpers/format-queries'
import Axios from 'src/helpers/axios'
import { getFullName } from 'src/helpers/text-format'
import {
  CDateRangePicker,
  CFormSelect,
  CCol,
  CRow,
  CCollapse,
  CFormLabel
} from '@coreui/react-pro'
import AppCardHeader from 'src/components/card/AppCardHeader'

const CustomerList = () => {
  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })

  const [customerList, setCustomerList] = useState([]);
  const [customerListCount, setCustomerListCount] = useState(0);
  const [customerListPerPage, setCustomerListPerPage] = useState(10);
  const [activeCustomerListPage, setActiveCustomerListPage] = useState(1);
  const [searchCustomerListFilter, setSearchCustomerListFilter] = useState("");
  const [columnCustomerListSorter, setColumnCustomerListSorter] = useState({ column: "id", state: "desc" });

  // field filter
  const [visibleFilterField, setVisibleFilterField] = useState(false)
  const [filterStartLastBookingDate, setFilterStartLastBookingDate] = useState(null)
  const [filterEndLastBookingDate, setFilterEndLastBookingDate] = useState(null)
  const [filterStartFirstBookingDate, setFilterStartFirstBookingDate] = useState(null)
  const [filterEndFirstBookingDate, setFilterEndFirstBookingDate] = useState(null)
  const [filterNumberCompletedBooking, setFilterNumberCompletedBooking] = useState('')
  const filterNumberCompletedBookingOptions = [{
    value: '',
    label: 'Please select...'
  }, {
    value: '1',
    label: '>= 1'
  }, {
    value: '5',
    label: '>= 5'
  }, {
    value: '10',
    label: '>= 10'
  }, {
    value: '25',
    label: '>= 25'
  }, {
    value: '50',
    label: '>= 50'
  }]

  // column filter for created on
  const [startDate, setStartDate] = useState(new Date('2022-01-01'))
  const [endDate, setEndDate] = useState(new Date())

  useEffect(() => {
    let queries = {
      search: searchCustomerListFilter,
      limit: customerListPerPage,
      offset: customerListPerPage * activeCustomerListPage - customerListPerPage,
      sort:
        columnCustomerListSorter &&
          columnCustomerListSorter.column &&
          columnCustomerListSorter.state &&
          columnCustomerListSorter.column !== "" &&
          columnCustomerListSorter.state !== "" &&
          columnCustomerListSorter.state != 0 ?
          `${columnCustomerListSorter.column}%${columnCustomerListSorter.state}` : "id%desc",
      ...filterStartLastBookingDate && filterEndLastBookingDate ? {
        startDateLastBooking: moment(filterStartLastBookingDate).format('YYYY-MM-DD'),
        endDateLastBooking: moment(filterEndLastBookingDate).format('YYYY-MM-DD')
      } : {},
      ...filterStartFirstBookingDate && filterEndFirstBookingDate ? {
        startDateFirstBooking: moment(filterStartFirstBookingDate).format('YYYY-MM-DD'),
        endDateFirstBooking: moment(filterEndFirstBookingDate).format('YYYY-MM-DD')
      } : {},
      ...filterNumberCompletedBooking && filterNumberCompletedBooking !== '' ? {
        numberCompletedBookings: filterNumberCompletedBooking
      } : {}
    };
    queries = formUrlQuery(queries);
    fetchAllCustomers(queries);
  }, [
    searchCustomerListFilter,
    customerListPerPage,
    activeCustomerListPage,
    columnCustomerListSorter,
    filterStartLastBookingDate,
    filterEndLastBookingDate,
    filterStartFirstBookingDate,
    filterEndFirstBookingDate,
    filterNumberCompletedBooking
  ]);

  const fetchAllCustomers = (queries) => {
    Axios({
      method: "get",
      url: `/api/sso/v1/users/regular?${queries}`,
      // url: `/api/booking/v1/bookings/guest/registered/all?${queries}`
    })
      .then(({ data }) => {
        const result = data && data.users
        const count = data && data.count
        const tempCustomerList = result.map((d) => ({
          ...d,
          first_name: d?.profile?.first_name || "-",
          last_name: d?.profile?.last_name || "-",
          first_booking_on: new Date()
        }));

        setCustomerList(tempCustomerList);
        setCustomerListCount(count);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleDeleteConfirmation = (item) => {
    Axios({
      method: "delete",
      url: `/api/booking/v1/customers/${item.id}`,
    })
      .then(({ data }) => {
        setShowConfirmDelete({ show: false, item: {} })
        window.location.reload()
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const handleOpenFilterField = () => {
    setVisibleFilterField(!visibleFilterField)
    setFilterStartLastBookingDate(null)
    setFilterEndLastBookingDate(null)
    setFilterStartFirstBookingDate(null)
    setFilterEndFirstBookingDate(null)
    setFilterNumberCompletedBooking('')
  }

  return (
    <>
      {showConfirmDelete.show && (
        <AppModalConfirmation
          confirmationType='delete-item'
          itemName='customer'
          itemDetails={showConfirmDelete.item}
          showModal={showConfirmDelete}
          setShowModal={setShowConfirmDelete}
          handleConfirmation={handleDeleteConfirmation}
        />
      )}
      <AppCard
        className='mb-4'
        headerTitle={
          <AppCardHeader
            headerTitle={<h4>Customer List</h4>}
          // headerButton="Filter By"
          // handleCardHeaderButton={handleOpenFilterField}
          />
        }
        bodyContent={
          <>
            <CCollapse visible={visibleFilterField}>
              <CRow className="mb-3">
                <CCol lg={4}>
                  <CFormLabel>
                    First Booking On:
                  </CFormLabel>
                  <CDateRangePicker
                    startDate={filterStartFirstBookingDate}
                    endDate={filterEndFirstBookingDate}
                    maxDate={new Date()}
                    onStartDateChange={(date) => {
                      setFilterStartFirstBookingDate(date)
                    }}
                    onEndDateChange={(date) => {
                      setFilterEndFirstBookingDate(date)
                    }}
                  />
                </CCol>
                <CCol lg={4}>
                  <CFormLabel>
                    Last Booking On:
                  </CFormLabel>
                  <CDateRangePicker
                    startDate={filterStartLastBookingDate}
                    endDate={filterEndLastBookingDate}
                    maxDate={new Date()}
                    onStartDateChange={(date) => {
                      setFilterStartLastBookingDate(date)
                    }}
                    onEndDateChange={(date) => {
                      setFilterEndLastBookingDate(date)
                    }}
                  />
                </CCol>
                <CCol lg={4}>
                  <CFormLabel>
                    Number # Of Completed Bookings:
                  </CFormLabel>
                  <CFormSelect
                    options={filterNumberCompletedBookingOptions}
                    value={filterNumberCompletedBooking}
                    onChange={({ target: { value } }) => {
                      setFilterNumberCompletedBooking(value)
                    }}
                  />
                </CCol>
              </CRow>
            </CCollapse>
            <AppTable
              customerListPage
              tableFilter={{ external: true }}
              setShowConfirmDelete={setShowConfirmDelete}
              tableColumns={columnCustomerList()}
              tableContent={customerList}
              contentPerPage={customerListPerPage}
              activeContentPage={activeCustomerListPage}
              contentCount={customerListCount}
              searchContentFilter={searchCustomerListFilter}
              setActiveContentPage={setActiveCustomerListPage}
              setSearchContentFilter={setSearchCustomerListFilter}
              setContentPerPage={setCustomerListPerPage}
              setColumnContentSorter={setColumnCustomerListSorter}
              startDateColumnFilter={startDate}
              endDateColumnFilter={endDate}
            />
          </>
        }
      />
    </>
  )
}

export default CustomerList
